import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const CurrentPregnancyChartsDataContext = createContext();

const CurrentPregnancyChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.CURRENT_PREGNANCY_LIVE_BIRTHS,
            url: 'governanceroom/dashboard/vitalstatistics/live-births/current-pregnancy'
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  mothersLessThan7ConsutationsPrenatal:
                      data?.indicators?.mothersLessThan7ConsutationsPrenatal ?? 0
              },
              preNatalConsultations: data?.preNatalConsultations ?? [],
              prenatalStartMonth: data?.prenatalStartMonth ?? [],
              pregnanciesWeeks: data?.pregnanciesWeeks ?? [],
              typesOfBirthsOnPreviosPregnancies:
                  data?.typesOfBirthsOnPreviosPregnancies ?? [],
              method: data?.method ?? [],
              occurenceLocation: data?.occurenceLocation ?? [],
              pregnancyTypes: data?.pregnancyTypes ?? []
          }
        : {
              indicators: {
                  mothersLessThan7ConsutationsPrenatal: 0
              },
              preNatalConsultations: [],
              prenatalStartMonth: [],
              pregnanciesWeeks: [],
              typesOfBirthsOnPreviosPregnancies: [],
              method: [],
              occurenceLocation: [],
              pregnancyTypes: []
          };

    return (
        <CurrentPregnancyChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </CurrentPregnancyChartsDataContext.Provider>
    );
};

export default CurrentPregnancyChartsDataProvider;
